export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/ImageWorker.worker.8b1869f0dc24277f1b69.worker.js");
}
